import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-zohocallback',
  templateUrl: './zohocallback.component.html',
  styleUrls: ['./zohocallback.component.scss']
})
export class ZohocallbackComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
